import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {SortDirection as SortDirections} from 'src/openapi/admin/models/SortDirection';

import {SortHeaderWithDataTable} from '@pb/kit-component-sort-header';

import {
    presetsStateActions,
    presetsStateSelector,
} from '../slices/presets-state.slice';

import type {SortDirection} from 'src/openapi/admin/models/SortDirection';

export const PresetNameHeader = () => {
    const dispatch = useDispatch();
    const cacheKeys = useSelector(presetsStateSelector);

    const sort = useCallback((direction: ('ASC' | 'DESC')) => {
        const sortCriteria = {
            direction: direction as SortDirection,
            field: undefined,
        };

        dispatch(presetsStateActions.setSortCriteria(sortCriteria));
    }, [dispatch]);

    return (
        <SortHeaderWithDataTable
            defaultDirection={SortDirections.ASC}
            direction={cacheKeys.sortCriteria.direction}
            filterActive={true}
            caption="Preset/Role/Resource"
            onSort={sort}
        />
    );
};
